var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeriesSettings01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3 {\n        fill: none;\n      }\n\n      .cls-1, .cls-3 {\n        stroke: #000;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        stroke: #030708;\n        fill-rule: evenodd;\n      }\n\n      .cls-3 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Series Settings") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.2,51.59h0a2.17,2.17,0,0,1,2-3.13h45.1a2.16,2.16,0,0,1,1.77,3.46h0a2.2,2.2,0,0,1-1.77.87H4.18A2.23,2.23,0,0,1,2.2,51.59Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 50.58,
    y1: 34.41,
    x2: 50.29,
    y2: 48.7
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "3.34 47.92 3.34 15.45 31.1 15.45"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "47.71 33.58 47.71 45.75 5.5 45.75 5.5 18.69 30.73 18.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58.09,20.88,54.39,20a.57.57,0,0,1-.41-.41,12.87,12.87,0,0,0-1-2.33.57.57,0,0,1,0-.58l2-3.27a.59.59,0,0,0-.09-.72l-2.22-2.22a.6.6,0,0,0-.72-.09l-3.27,2a.63.63,0,0,1-.58,0,11.68,11.68,0,0,0-2.33-1,.58.58,0,0,1-.4-.42l-.93-3.7a.58.58,0,0,0-.57-.44H40.73a.59.59,0,0,0-.57.44l-.93,3.7a.58.58,0,0,1-.4.42,11.68,11.68,0,0,0-2.33,1,.63.63,0,0,1-.58,0l-3.27-2a.6.6,0,0,0-.72.09l-2.22,2.22a.59.59,0,0,0-.09.72l2,3.27a.57.57,0,0,1,0,.58,12.16,12.16,0,0,0-1,2.33.6.6,0,0,1-.42.41l-3.7.92a.59.59,0,0,0-.44.57v3.14a.58.58,0,0,0,.44.57l3.7.93a.58.58,0,0,1,.42.4,12,12,0,0,0,1,2.34.55.55,0,0,1,0,.57l-2,3.27a.59.59,0,0,0,.09.72l2.22,2.22a.59.59,0,0,0,.72.09l3.27-2a.57.57,0,0,1,.58,0,11.68,11.68,0,0,0,2.33,1,.57.57,0,0,1,.4.41l.93,3.7a.6.6,0,0,0,.57.45h3.14a.59.59,0,0,0,.57-.45l.93-3.7a.57.57,0,0,1,.4-.41,11.68,11.68,0,0,0,2.33-1,.57.57,0,0,1,.58,0l3.27,2a.59.59,0,0,0,.72-.09l2.22-2.22a.59.59,0,0,0,.09-.72L53,29.4a.55.55,0,0,1,0-.57,12.67,12.67,0,0,0,1-2.34.56.56,0,0,1,.41-.4l3.7-.93a.59.59,0,0,0,.45-.57V21.45A.6.6,0,0,0,58.09,20.88Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 42.3,
    cy: 23.02,
    r: 8.66
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "40.3 20.75 37.27 23.02 40.3 25.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "44.84 20.75 47.88 23.02 44.84 25.3"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 43.71,
    y1: 19.23,
    x2: 41.43,
    y2: 26.81
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeriesSettings01);
export default __webpack_public_path__ + "static/media/Series_Settings_01.0e3d69654776788586164142b455fc97.svg";
export { ForwardRef as ReactComponent };